<div *ngIf="type() && type() === 'keytool'">
    <label for="keytool">
        <i class="upload-icon fa-solid fa-upload"></i>
        <input (change)="onKeytoolUpload($event)" type="file" id="keytool" style="display: none">
    </label>
</div>

<div *ngIf="type() && type() === 'store'">
    <label for="store">
        <i class="upload-icon fa-solid fa-upload"></i>
        <input (change)="onStoreUpload($event)" type="file" id="store" style="display: none">
    </label>
</div>
